import { useState } from "react";
import axios from "axios";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { API } from "../App";
import { Leaf, Lock, Check } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <main className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="reset-password-page">
        <div className="max-w-md w-full text-center">
          <Leaf className="w-10 h-10 text-tc-primary mx-auto mb-6" />
          <p className="font-serif text-3xl text-tc-primary italic">Link non valido</p>
          <Link to="/login" className="btn-outline mt-6 inline-block">Torna al login</Link>
        </div>
      </main>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    if (pw.length < 8) { toast.error("Almeno 8 caratteri"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pw });
      setDone(true);
      toast.success("Password aggiornata");
      setTimeout(() => navigate("/login", { replace: true }), 2500);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="reset-password-page">
      <div className="max-w-md w-full">
        <Leaf className="w-10 h-10 text-tc-primary mx-auto mb-6" />
        <h1 className="font-serif text-4xl text-tc-primary text-center leading-tight">
          Scegli una<br/><em className="text-tc-secondary italic">nuova password</em>
        </h1>

        {done ? (
          <div className="bg-tc-surface rounded-3xl p-8 border border-tc/40 text-center mt-10" data-testid="reset-done">
            <Check className="w-8 h-8 text-tc-accent mx-auto mb-4" />
            <p className="text-tc-primary font-serif text-xl italic">Tutto pronto.</p>
            <p className="text-sm text-tc-muted mt-3">Ti stiamo portando al login…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="reset-form">
            <div className="flex items-center gap-3 border-b border-tc focus-within:border-tc-primary py-2">
              <Lock className="w-4 h-4 text-tc-muted" />
              <input type="password" required minLength={8} value={pw} onChange={e => setPw(e.target.value)}
                placeholder="Nuova password (min 8 caratteri)"
                className="flex-1 bg-transparent outline-none text-sm" data-testid="reset-pw" />
            </div>
            <div className="flex items-center gap-3 border-b border-tc focus-within:border-tc-primary py-2">
              <Lock className="w-4 h-4 text-tc-muted" />
              <input type="password" required minLength={8} value={pw2} onChange={e => setPw2(e.target.value)}
                placeholder="Ripeti la password"
                className="flex-1 bg-transparent outline-none text-sm" data-testid="reset-pw2" />
            </div>
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit">
              {busy ? "Salvo…" : "Imposta nuova password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
